import * as React from 'react';

import { useSelector } from 'react-redux';

import { Typography } from '@emburse/ui-core';

import { ConfirmModal, IConfirmModalProps } from '@ReactComponents/ConfirmModal';

import { IAppStateContainer } from '@Reducers/index';

interface IAmexBalanceResetConfirmModalProps extends Pick<IConfirmModalProps, 'closeModal' | 'onConfirm'> {}

/**
 * When editing an Amex CPG virtual card, if you edit the amount, the balance is reset to 0
 * This is a confirmation modal to make sure that the user understands this
 * @param props.onConfirm Confirm button handler
 * @returns
 */
export const AmexBalanceResetConfirmModal: React.FC<IAmexBalanceResetConfirmModalProps> = (props) => {
  const loading = useSelector((state: IAppStateContainer) => state.cardsGatewayIssuingModal.loading);

  return (
    <ConfirmModal headerText="Reset Balance" confirmText="Update" confirmButtonColor="error" isLoading={Boolean(loading)} {...props}>
      <Typography gutterBottom>
        You are trying to update this card's budget. This action will also reset the card's current balance to 0.
      </Typography>
      <Typography style={{ marginBottom: '30px' }}>Are you sure you want to perform the update and reset the card's balance?</Typography>
    </ConfirmModal>
  );
};
